import { SystemStyleObject } from '@mui/system'
import { Theme } from '@mui/material/styles'

export const MAX_HEIGHT = 'calc(100vh - 96px)'

export const paperStyles: SystemStyleObject<Theme> = {
  overflow: 'visible',
  backdropFilter: theme => theme.shape.borderBlur,
  backgroundColor: theme => theme.palette.transparent.light,
  padding: { xs: 0, sm: 2 },
  borderRadius: 3,
}

export const contentStyles = (color?: string, borderStyle: string = 'solid'): SystemStyleObject<Theme> => ({
  borderWidth: 0.5,
  borderColor: { xs: 'contrast.low', sm: color },
  borderStyle,
  borderRadius: 2,
  backgroundColor: 'background.default',
  overflow: 'hidden',
  maxHeight: MAX_HEIGHT,
})
